<template>
  <section class="box" dir="rtl">
    <!-- Banner -->
    <div
      class="products-banner"
      v-if="bannerImage"
      @click="$router.push('/products')"
      style="cursor: pointer"
    >
      <img :src="bannerImage" :alt="bannerTitle" class="banner-bg" />
      <div class="banner-overlay" />
      <div class="banner-content">
        <h2 class="banner-title">{{ bannerTitle }}</h2>
        <p class="banner-desc">{{ bannerDesc }}</p>
        <button class="banner-btn" @click.stop="$router.push('/products')">
          לכל המוצרים
        </button>
      </div>
    </div>
    <h2 v-else-if="ShowTitle" class="section-title">{{ bannerTitle }}</h2>
    <div
      :class="[ShowTitle ? 'mt-5' : '']"
      class="carousel-wrapper"
      :style="{ '--carousel-slide-width': slideWidthPercent + '%' }"
    >
      <Carousel
        :pauseAutoplayOnHover="true"
        :wrap-around="true"
        :breakpoints="breakpoints"
        :autoplay="5000"
        :dir="'rtl'"
      >
        <Slide v-for="(product, index) in products" :key="product.part">
          <productItem
            dir="rtl"
            :product="product"
            :TheCounter="product.quant"
            :auth-status="isAuthenticated"
            :priceListId="priceListId"
            @click="navigateToProduct(index)"
            @updateProduct="updateProduct"
          />
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </section>
</template>

<script>
import productItem from "../productItem.vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default {
  emits: ["updateProduct"],
  components: {
    productItem,
    Carousel,
    Slide,
    // Pagination,
    Navigation,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    breakpoints: {
      type: Object,
    },
    ShowTitle: {
      type: Boolean,
      default: false,
    },
    isAuthenticated: {
      type: Boolean,
    },
    priceListId: {
      type: String,
    },
    bannerImage: {
      type: String,
      default: null,
    },
    bannerTitle: {
      type: String,
      default: "מוצרים חמים",
    },
    bannerDesc: {
      type: String,
      default: "המוצרים הנמכרים ביותר באתר",
    },
    slideWidthPercent: {
      type: Number,
      default: 99,
    },
  },
  data() {
    return {
      model: null,
    };
  },
  methods: {
    navigateToProduct(index) {
      const product = this.products[index];

      if (this.$route.name === "CategoryProducts") {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            productId: product.part,
          },
        });
        return;
      }

      this.$router.push({
        path: `/products/${product.part}`,
      });
    },
    updatePartRquestAddToPriceList(partId) {
      this.$emit("updatePartRquestAddToPriceList", partId);
    },
    updateProduct(updObj) {
      this.$emit("updateProduct", updObj);
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.carousel__slide div:first-child) {
  width: var(--carousel-slide-width, 99%) !important;
}
// :deep(.carousel__track) {
//   gap: 20px !important;
// }
// .carousel__slide {
//   width: auto !important;
//   padding: 0 !important;
// }
// .carousel-wrapper {
//   padding: 20px;

//   :deep(.carousel__slide) {
//     padding: 0 8px;
//   }

//   :deep(.carousel__pagination) {
//     margin-top: 20px;
//   }

//   :deep(.carousel__prev),
//   :deep(.carousel__next) {
//     background-color: rgba(201, 199, 199, 0.52);
//     border-radius: 50%;
//     width: 32px;
//     height: 32px;

//     &:hover {
//       background-color: rgba(0, 0, 0, 0.308);
//     }
//   }
// }
h2 {
  text-align: center;
  font-family: Heebo;
  font-size: 35px;
  font-weight: 300;
  margin-bottom: 40px;
}
.isTablet,
.isMobile {
  .carousel-wrapper {
    padding: 5px !important;
  }
}

/* ─── Banner ─────────────────────────────── */
.products-banner {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 24px;

  .banner-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .banner-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to left,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.08) 100%
    );
  }

  .banner-content {
    position: absolute;
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    text-align: right;
    color: #fff;
  }

  .banner-title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 6px;
    font-family: Heebo, sans-serif;
    text-align: right;
    color: #fff !important;
  }

  .banner-desc {
    font-size: 15px;
    margin-bottom: 16px;
    opacity: 0.9;
    color: #fff !important;
  }

  .banner-btn {
    display: inline-block;
    padding: 10px 24px;
    border: 2px solid #fff;
    border-radius: 30px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    background: transparent;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    font-family: Heebo, sans-serif;

    &:hover {
      background: #fff;
      color: #333;
    }
  }
}

.section-title {
  text-align: center;
  font-family: Heebo, sans-serif;
  font-size: 35px;
  font-weight: 300;
  margin-bottom: 30px;
}
</style>
